import './ProfileDescription.scss';

import { CompanyName } from "../../../common-components/CompanyName/CompanyName";

const ProfileDescription = ({branch, company}) => {

    return (
        <div className={"profile-card-description"}>
            <div className={"profile-card-description_container"}>
                <div className={"profile-card-description_company"}>
                    <CompanyName company={company}/>
                </div>
                <span>
                    {"/"}
                </span>
                <div className={"profile-card-description_branch"}>
                    {branch}
                </div>
            </div>
        </div>
    )
}

export default ProfileDescription;